export default __webpack_public_path__ + "static/media/offer_tag.cf72cdc6.svg";